import { debounce } from './utils.js';

class HeaderCountdown extends HTMLElement {
  constructor() {
    super();
    this.endDate = null;
    this.countdownInterval = null;
    this.scrollHandler = null;
    this.headerElement = null;
    this.fixedElement = null;
    this.headerContainer = null;
    this.fixedContainer = null;
    this.textTemplate = '';
    this.expiredText = '';
  }

  connectedCallback() {
    this.cacheElements();
    this.parseAttributes();
    this.initializeCountdown();
    this.setupScrollListener();
  }

  disconnectedCallback() {
    this.cleanup();
  }

  cacheElements() {
    this.headerElement = this.querySelector('.header-countdown--header');
    this.fixedElement = this.querySelector('.header-countdown--fixed');
    this.headerContainer = this.headerElement?.querySelector('.header-countdown__container');
    this.fixedContainer = this.fixedElement?.querySelector('.header-countdown__container');
    this.textTemplate = JSON.parse(this.getAttribute('data-countdown-text'));
    this.expiredText = JSON.parse(this.getAttribute('data-countdown-expired-text'));
  }

  parseAttributes() {
    const endDateAttr = this.getAttribute('data-end-date');
    if (endDateAttr) {
      this.endDate = new Date(endDateAttr.replace(' ', 'T')).getTime();
    }
  }

  initializeCountdown() {
    if (!this.endDate) return;

    this.updateCountdown();
    this.countdownInterval = setInterval(() => {
      this.updateCountdown();
    }, 1000);
  }

  updateCountdown() {
    if (!this.endDate) return;

    const now = Date.now();
    const timeDiff = Math.floor((this.endDate - now) / 1000);

    if (timeDiff <= 0) {
      this.showExpired();
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }
      return;
    }

    const days = Math.floor(timeDiff / 86400);
    const remainingSeconds = timeDiff % 86400;
    const hours = Math.floor(remainingSeconds / 3600);
    const remainingMinutes = remainingSeconds % 3600;
    const minutes = Math.floor(remainingMinutes / 60);

    const formattedDays = String(days).padStart(2, '0');
    const formattedHours = String(hours).padStart(2, '0');
    const formattedMinutes = String(minutes).padStart(2, '0');

    const countdownText = `${formattedDays}:${formattedHours}:${formattedMinutes}`;
    const displayText = this.textTemplate.replace(/##countdown##/g, countdownText);

    if (this.headerContainer) {
      this.headerContainer.innerHTML = displayText;
    }

    if (this.fixedContainer) {
      this.fixedContainer.innerHTML = displayText;
    }
  }

  showExpired() {
    if (this.headerContainer) {
      this.headerContainer.innerHTML = this.expiredText;
    }
    if (this.fixedContainer) {
      this.fixedContainer.innerHTML = this.expiredText;
    }
  }

  setupScrollListener() {
    window.addEventListener('scroll', () => this.handleScroll());
    this.handleScroll();
  }

  handleScroll() {
    if (!this.fixedElement) return;

    const scrollY = window.scrollY || window.pageYOffset;
    const shouldShowFixed = scrollY > 0;

    if (shouldShowFixed) {
      this.fixedElement.classList.add('is-active');
    } else {
      this.fixedElement.classList.remove('is-active');
    }
  }

  cleanup() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }

    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler);
      this.scrollHandler.cancel();
      this.scrollHandler = null;
    }
  }
}

customElements.define('header-countdown', HeaderCountdown);

